import { TableColumnMeta } from "ds/components/Table/types";

export const FLOWS_PROJECT_ROLES_STORAGE_KEY = "flowsProjectRolesTable";
export const FLOWS_PROJECT_ROLES_FILTERS_STORAGE_KEY = "flowsProjectRolesFilters";

export const FLOWS_PROJECT_ROLES_REFETCH_QUERIES = ["FlowsProjectRoleBindingsWithRoles"];

export enum FLOWS_PROJECT_ROLES_COLUMN_ID {
  ROLE = "ROLE",
  DESCRIPTION = "DESCRIPTION",
  SPACE = "SPACE",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 600;

export const FLOWS_PROJECT_ROLES_COLUMN_CONFIG: Record<
  FLOWS_PROJECT_ROLES_COLUMN_ID,
  TableColumnMeta
> = {
  [FLOWS_PROJECT_ROLES_COLUMN_ID.ROLE]: {
    id: FLOWS_PROJECT_ROLES_COLUMN_ID.ROLE,
    title: "Role",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [FLOWS_PROJECT_ROLES_COLUMN_ID.DESCRIPTION]: {
    id: FLOWS_PROJECT_ROLES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 200,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [FLOWS_PROJECT_ROLES_COLUMN_ID.SPACE]: {
    id: FLOWS_PROJECT_ROLES_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 120,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [FLOWS_PROJECT_ROLES_COLUMN_ID.ROW_ACTIONS]: {
    id: FLOWS_PROJECT_ROLES_COLUMN_ID.ROW_ACTIONS,
    title: "",
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const FLOWS_PROJECT_ROLES_SORT_CONFIG = {
  [FLOWS_PROJECT_ROLES_COLUMN_ID.ROLE]: "role",
  [FLOWS_PROJECT_ROLES_COLUMN_ID.SPACE]: "space",
};
